module.exports = __webpack_public_path__ + "media/images/flags/pn-6a184f43119a1d196f3fc0bd6e8dea3b.svg";